import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n        height: 25px;\n        margin: 0 5px;\n        width: 25px;\n\n        &:nth-child(n + 5) {\n          display: none;\n        }\n\n        @media (max-width: 320px) {\n          height: 23px;\n          margin: 0 3px;\n          width: 23px;\n        }\n\n        &:first-child {\n          margin-left: 0;\n        }\n      '], ['\n        height: 25px;\n        margin: 0 5px;\n        width: 25px;\n\n        &:nth-child(n + 5) {\n          display: none;\n        }\n\n        @media (max-width: 320px) {\n          height: 23px;\n          margin: 0 3px;\n          width: 23px;\n        }\n\n        &:first-child {\n          margin-left: 0;\n        }\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        height: 40px;\n        width: 40px;\n      '], ['\n        height: 40px;\n        width: 40px;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      display: block;\n      height: 33px;\n      margin: 0;\n      width: 100%;\n    '], ['\n      display: block;\n      height: 33px;\n      margin: 0;\n      width: 100%;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      margin: 0;\n      width: 100%;\n    '], ['\n      margin: 0;\n      width: 100%;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin: 5px;\n  position: relative;\n\n  input {\n    opacity: 0;\n    position: absolute;\n\n    &:focus + label {\n      outline: 3px auto ', ';\n    }\n  }\n\n  ', '\n'], ['\n  display: inline-block;\n  margin: 5px;\n  position: relative;\n\n  input {\n    opacity: 0;\n    position: absolute;\n\n    &:focus + label {\n      outline: 3px auto ', ';\n    }\n  }\n\n  ', '\n']);

import styled, { css } from 'styled-components';

var RadioStyleTypes = function RadioStyleTypes(_ref) {
  var type = _ref.type,
      parent = _ref.parent,
      theme = _ref.theme;

  if (type === 'SWATCH') {
    if (parent === 'CollectionCard__swatch-container') {
      return css(_templateObject);
    } else {
      return css(_templateObject2);
    }
  } else if (type == 'SWATCH_DROPDOWN') {
    return css(_templateObject3);
  } else if (type == 'DROPDOWN') {
    return css(_templateObject4);
  }
};

export var StyledLi = styled.li(_templateObject5, function (props) {
  return props.theme.dormifyPink;
}, RadioStyleTypes);